import { useMemo } from 'react';

import { useAtomValue, useSetAtom } from 'jotai';

import {
  azarTokenAtom,
  isUserJustSignedUpAtom,
  loginOAuthAtom,
  removeTokenAtom,
  userDataAtom,
} from 'src/stores/auth/atoms';

const useLogin = () => {
  const { userId } = useAtomValue(userDataAtom) ?? {};
  const isUserJustSignedUp = useAtomValue(isUserJustSignedUpAtom);
  const logout = useSetAtom(removeTokenAtom);
  const loginOAuth = useSetAtom(loginOAuthAtom);
  const azarToken = useAtomValue(azarTokenAtom);
  const hasToken = useMemo(() => !!azarToken, [azarToken]);

  if (hasToken && userId) {
    return {
      isLogin: true,
      userId,
      logout,
      loginOAuth,
      isUserJustSignedUp,
    } as const;
  }

  return {
    isLogin: false,
    userId: undefined,
    logout,
    loginOAuth,
    isUserJustSignedUp,
  } as const;
};

export default useLogin;
